import React from "react";
import { ToastContainer, toast } from 'react-toastify';
import { createRoot } from 'react-dom/client';
import App from "./App";
import Modal from "react-modal";

Modal.setAppElement("#root");

const container = document.getElementById('root');
const root = createRoot(container);
root.render(
    <>
        <App />
        <ToastContainer />
    </>
);